import React from "react";
import {Box} from "@mui/material";


export const tabContainer = {
    p: 3,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#ffffff',
};

export const tabContent = {
    paddingTop: '1em',
    paddingBottom: '1em',
    fontFamily: 'Jost-Regular',
    width: {
        xs: '100%',
        sm: '80%',
        md: '70%',
        lg: '50%',
    },
    pl: 2,
    pr: 2,
};

const CommonTab = ({children}) => {
    return (
        <Box>
            <Box sx={tabContainer}>
                <Box sx={tabContent}>
                    {children}
                </Box>
            </Box>
        </Box>
    );
};

export default CommonTab;

